// extracted by mini-css-extract-plugin
export default {"partners-container":"Partners_partners-container__bwtYZ","partner-image":"Partners_partner-image__o5aaC"};